module.exports = __webpack_public_path__ + "static/img/free-bg.459489f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fathers-day-2026/free-bg.png
// module id = qUPJ
// module chunks = 2